"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProgressSteps;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function ProgressSteps(props) {
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const getIcon = (stepError, index) => {
        if (props.currentStep == index + 1 && stepError)
            return Theme_1.ICONS.Solid.CircleXmark;
        else if (stepError)
            return Theme_1.ICONS.Regular.CircleXmark;
        else if (props.currentStep == index + 1)
            return Theme_1.ICONS.Solid.Circle;
        else if (props.currentStep > index + 1)
            return Theme_1.ICONS.Solid.CircleCheck;
        else
            return Theme_1.ICONS.Regular.Circle;
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { backgroundColor: `${THEME.Primary}11`, paddingHorizontal: 12, paddingBottom: 6, paddingTop: size != 'sm' ? 6 : 0, marginTop: 6, borderRadius: 5 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginVertical: 6 }, children: props.stepErrors.map((_item, _index) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: getIcon(_item, _index), size: 18, color: _item ? THEME.Red : THEME.Primary }), _index + 1 != props.stepErrors.length &&
                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, borderBottomColor: THEME.Primary, borderBottomWidth: 2 } })] }, _index))) }), props.title &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 6 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 16 : 14, marginLeft: 12 }, children: `${props.currentStep} — ${props.title}` }) })] }));
}
